import { render, staticRenderFns } from "./ThemeCompSwitch.vue?vue&type=template&id=43a0dc12"
import script from "./ThemeCompSwitch.vue?vue&type=script&lang=js"
export * from "./ThemeCompSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports